import React, { useState } from "react";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import localization from "assets/localization/localization";
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import DatePicker from "components/sales/datePicker/datePicker";
import Images from "assets/images/imageData";

const QuotationFilter = ({
    applyFilter,
    localstorageKey = ''
}) => {
    const filterInputs = {
        project_id: "",
        client_name: "",
        status: '',
        created_at: ''
    };

    const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);
    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                applyFilter(filterFieldsData);
                filterFieldsData && localStorage.setItem("help_desk_users", JSON.stringify(filterFieldsData));
            }}
        >
            <ConstantInput
                label={"Project Id"}
                value={filterFieldsData && filterFieldsData.project_id}
                type="text"
                handleChange={(val) => {
                    setFilterFieldsData({ ...filterFieldsData, project_id: val });
                }}
            />

            <ConstantInput
                label={"Client Name"}
                value={filterFieldsData && filterFieldsData.client_name}
                type="text"
                handleChange={(val) => {
                    setFilterFieldsData({ ...filterFieldsData, client_name: val });
                }}
            />
            <DropDownInput
                label="Status"
                data={[
                    {
                        id: 1,
                        name: "L1 Pending",
                    },
                    {
                        id: 2,
                        name: "L1 Approved",
                    },
                    {
                        id: 3,
                        name: "L1 Rejected",
                    },
                    {
                        id: 4,
                        name: "Client Approved",
                    },
                    {
                        id: 5,
                        name: "Client Rejected",
                    },
                    {
                        id: 6,
                        name: "L2 Approved",
                    },
                    {
                        id: 7,
                        name: "L2 Rejected",
                    },

                ]}
                errorMsg={`Status`}
                getIdValue={(val) => {
                    setFilterFieldsData({ ...filterFieldsData, status: val?.id });
                }}
            />
            <DatePicker
                required={false}
                label='Created At'
                value={filterFieldsData && filterFieldsData.created_at}
                handleChange={(value) => setFilterFieldsData({ ...filterFieldsData, created_at: value.split("-").reverse().join("-") })}
            />
            <br />
            <br />
            <br />

            <div className="btn-wrapper">
                <button disabled={false} type="submit" className="btn btn-primary">
                    {localization.applyFilter}
                    <img src={Images?.ArrowRight} alt="" />
                </button>
                <br />
                <br />
                <button
                    onClick={() => {
                        localStorage.setItem(localstorageKey, JSON.stringify(filterInputs));
                        applyFilter(filterInputs);
                        localStorage.setItem(localstorageKey, JSON.stringify({}));
                    }}
                    type="button"
                    className="btn btn-primary"
                >
                    {localization.removeFilter}
                </button>
            </div>
        </form>
    );
};

export default QuotationFilter;
